export default __webpack_public_path__ + "static/media/Create-documentation.19b80453.md";